module.exports = __webpack_public_path__ + "customer.e3d914d347a60df273c4b6e9cc8b8455.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/menu/selected/customer.svg
// module id = 334
// module chunks = 0